export enum PreparedResponseType {
  default = 'default',
  custom = 'custom',
  ending = 'ending',
  locationRequest = 'location_request',
  roadsideAssistance = 'roadside_assistance',
}

/**
 * Types an authority may assign to at most one message at a time. Setting one
 * of these on a message clears it from whichever message previously held it.
 * Every singleton type is guaranteed a rapidsos system default, so a preferred
 * message can always be resolved for one.
 */
export type SingletonResponseType =
  | PreparedResponseType.ending
  | PreparedResponseType.locationRequest
  | PreparedResponseType.roadsideAssistance;

export const SINGLETON_RESPONSE_TYPES: readonly PreparedResponseType[] = [
  PreparedResponseType.ending,
  PreparedResponseType.locationRequest,
  PreparedResponseType.roadsideAssistance,
];

/**
 * Human-readable name of the action each singleton type backs. Single source
 * of truth for the assigned-message slot labels and any UI that needs to name
 * the action a message is assigned to.
 */
export const SINGLETON_TYPE_ACTION_LABELS: Record<
  SingletonResponseType,
  string
> = {
  [PreparedResponseType.ending]: 'End Chat',
  [PreparedResponseType.locationRequest]: 'Location Request',
  [PreparedResponseType.roadsideAssistance]: 'Roadside Assistance',
};
